export const types = {
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning'
}
